import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import Table from "../../core/common/dataTable/index";
import api from "../../api"; // your custom API method
import useDynamicPageSize from "../../useDynamicPageSize";
import { useLocation, useNavigate } from "react-router-dom";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import StatCardGrid from "./statCardGrid";
import CommonSelect from "../../core/common/commonSelect";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../../Footer";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import { FaRecordVinyl } from "react-icons/fa";
import { Link } from "react-router-dom";

interface SalaryDetail {
  name: string;
  gross: number;
  incentive: number;
  security_deposit: number;
  tds: number;
  pt: number;
  pf: number;
  esic: number;
  net_amount: number;
  flag: boolean;
  year: string;
  month: string;
  employee_id: number;
}

interface LocationState {
  employeeName?: string;
  previousUrl?: string;
}

const EmployeeSalary: React.FC = () => {
  const location = useLocation();
  const pageSize = useDynamicPageSize();
  const navigate = useNavigate();
  const { setFilters } = useHeaderFilters();
  const [isMobileView, setIsMobileView] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const employeeId = queryParams.get("employeeId");
  const fiscalMonth = queryParams.get("month") || "";
  const year = queryParams.get("year") || "";
  const formatCurrency = (value: number | string) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(Number(value));

  const [salaryDetails, setSalaryDetails] = useState<SalaryDetail[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [summary, setSummary] = useState({
    totalGross: "",
    totalSD: "",
    totalTDS: "",
    totalNet: "",
  });
  const [id, setId] = useState<string>("");

 useEffect(() => {
  const state = location.state as LocationState;

  if (state?.employeeName && employeeId) {
    localStorage.setItem("employeeName", state.employeeName);
    localStorage.setItem("employeeId", employeeId);
  }
}, [location.state, employeeId]);

const employeeName = location.state?.employeeName || localStorage.getItem("employeeName") || "Unknown Employee";
const storedEmployeeId = employeeId || localStorage.getItem("employeeId") || "null";
  const previousUrl = location.state?.previousUrl;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedEmployees, setSelectedEmployees] = useState<number[]>([]);
  const [totalGross, setTotalGross] = useState("0");
  const [totalSD, setTotalSD] = useState("0");
  const [totalTDS, setTotalTDS] = useState("0");
  const [totalNet, setTotalNet] = useState("0");
  const [totalPF, setTotalPF] = useState("0");
  const [totalESIC, setTotalESIC] = useState("0");
  const [loading, setLoading] = useState(false);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const userRole = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}")?.role_name;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("pageTitle", "Monthly Salary");
    fetchEmployeeSalary();
  }, []);

 useLayoutEffect(() => {
  const calcHeight = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;

     
    const isTablet = w > 575 && w <= 991;
    const isMobile = w <= 575 || w <= 991;

    let topBlocks = 0;
    if (w <= 360)        topBlocks = 210;   
    else if (w <= 410)   topBlocks = 210;   
    else if (w <= 575)   topBlocks = 210;   
    else if (w <= 767)   topBlocks = 130;   
    else if (w <= 991)   topBlocks = 130;   
    else                 topBlocks = 110;  

    const pagination = document.getElementById("pagination-bar");
    const footer     = document.getElementById("footer");
    const paginationH = pagination?.offsetHeight ?? 56;
    const footerH     = footer?.offsetHeight ?? 50;

    const reserved = topBlocks + paginationH + footerH;
    const newHeight = Math.max(220, h - reserved);

    setTableHeight(newHeight);
  };

  calcHeight();                      // initial
  window.addEventListener("resize", calcHeight);
  return () => window.removeEventListener("resize", calcHeight);
}, []);
  const fetchEmployeeSalary = async () => {
    setIsLoading(true);
    try {
      const res: any = await api(`/monthly-employee/${year}/${employeeId}`, {
        method: "GET",
      });

      setSalaryDetails(res.monthdata || []);
      setId(res.id || "");
      setTotalGross(res.totalGross);
      setTotalNet(res.totalNet);
      setTotalSD(res.totalSD);
      setTotalTDS(res.totalTDS);
      setTotalPF(res.totalPF);
      setTotalESIC(res.totalESIC);
    } catch (err: any) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = async (detail: any) => {
    try {
      const response = await api<Blob>(
        `/create-pdf-file/${id}/${detail.year}/${detail.month}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        }
      );

      // Ensure employee ID, name, month, year are available
      const year = detail.year || "YYYY";
      const monthIndex = detail.month; // e.g., 4 for April

      console.log("Detail received:", detail);

      // Map month index (1–12 or 0–11) to full month name
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // Convert month number to name
      let monthName = "";
      if (typeof monthIndex === "number") {
        monthName = monthNames[monthIndex - 1]; // Assuming 1-based month
      } else if (!isNaN(Number(monthIndex))) {
        monthName = monthNames[Number(monthIndex) - 1];
      } else {
        monthName = monthIndex; // If it's already a name like "April"
      }

      const filename = `${storedEmployeeId}-${employeeName}-${monthName}-${year}-slip.pdf`;

      const blob = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      console.error("Error while generating PDF:", error);
      setErrorMessage("The requested payslips are not available.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 554);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const EmployeeSalaryFilters = () => (
      <div className="px-2 px-md-2">
        <div className="EmployeeSalary-filters d-flex align-items-center flex-wrap ">
          <div className="d-flex align-items-center gap-2  toggle-att-employeeSalary">
            <nav className="text-sm text-gray-600">
              {breadcrumbs.map((crumb, idx) => (
                <span key={idx}>
                  {crumb.path ? (
                    <Link
                      to={crumb.path}
                      className="text-blue-600 hover:underline"
                    >
                      {crumb.title}
                    </Link>
                  ) : (
                    <span>{crumb.title}</span>
                  )}
                  {idx < breadcrumbs.length - 1 && (
                    <span className="mx-2">/</span>
                  )}
                </span>
              ))}
            </nav>
          </div>
        </div>
      </div>
    );
    const EmployeeSalaryDesktopFilters = () => (
      <div className="px-2 px-md-2">
        <div className="EmployeeSalary-filters d-flex align-items-center flex-wrap ">
          <div className="d-flex align-items-center gap-2  toggle-att-employeeSalarymedia toggle-att-employeeSalarydesktop">
            <nav className="text-sm text-gray-600">
              {breadcrumbs.map((crumb, idx) => (
                <span key={idx}>
                  {crumb.path ? (
                    <Link
                      to={crumb.path}
                      className="text-blue-600 hover:underline"
                    >
                      {crumb.title}
                    </Link>
                  ) : (
                    <span>{crumb.title}</span>
                  )}
                  {idx < breadcrumbs.length - 1 && (
                    <span className="mx-2">/</span>
                  )}
                </span>
              ))}
            </nav>
          </div>
        </div>
      </div>
    );
    setFilters(
      isMobileView ? (
        <EmployeeSalaryFilters />
      ) : (
        <EmployeeSalaryDesktopFilters />
      )
    );
    return () => {
      console.log("cleaning up filters");
      setFilters(null);
    };
  }, [isMobileView, setFilters]);

  const breadcrumbs = [
    // always show “Payroll”
    { title: "Payroll", path: previousUrl || "/payroll" },

    // only show the month crumb if monthYear is set
    ...(employeeName
      ? [
          {
            title: employeeName,
            // clicking takes you back to payroll
            path: previousUrl || "/payroll",
          },
        ]
      : []),
  ];

  const columns = [
    {
      title: "Months",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Gross [₹]",
      dataIndex: "gross",
      key: "gross",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "Inct [₹]",
      dataIndex: "incentive",
      key: "incentive",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "SD [₹]",
      dataIndex: "security_deposit",
      key: "security_deposit",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "TDS [₹]",
      dataIndex: "tds",
      key: "tds",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "PT [₹]",
      dataIndex: "pt",
      key: "pt",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "PF[₹]",
      dataIndex: "pf",
      key: "pf",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },
    {
      title: "ESIC[₹]",
      dataIndex: "esic",
      key: "esic",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },
    {
      title: "Net [₹]",
      dataIndex: "net_amount",
      key: "net_amount",
      align: "right",
      render: (val: number) => val.toLocaleString("en-IN"),
    },
    {
      title: "Status",
      key: "flag",
      dataIndex: "flag",
      align: "center",
      render: (flag: boolean) =>
        flag ? (
          <span className="badge bg-success text-white">Disbursed</span>
        ) : null,
    },
    {
      title: "Action",
      key: "action",
      render: (_text: any, detail: SalaryDetail) =>
        detail.flag ? (
          <button
            className="btn btn-icon"
            title="Download"
            onClick={() => handleDownloadPdf(detail)}
          >
            <i className="fa fa-download" />
          </button>
        ) : null,
    },
  ];

  const stats = [
    { title: "Gross", value: totalGross },
    { title: "SD", value: totalSD },
    { title: "TDS", value: totalTDS },
    { title: "PF", value: totalPF },
    { title: "ESIC", value: totalESIC },
    { title: "Net", value: totalNet },
  ];

  return (
    <div className="page-wrapper d-flex flex-column">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="content flex-grow-1">
        {userRole === 1 && (
          <StatCardGrid
            items={stats}
            formatValue={formatCurrency}
            currencySymbol
          />
        )}
        <div className="card card-margin-bottom ">
          <div className="card-body p-0">
            <Table
              style={{ height: `${tableHeight}px` }}
              columns={columns}
              dataSource={salaryDetails}
              totalItems={totalItems}
              Selection={false}
              pageSize={pageSize}
              currentPage={currentPage}
              loading={loading}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default EmployeeSalary;
